import React, { useEffect, useState } from "react";
import AuthService from "services/auth.service";
import checkMark from "../assets/img/check-mark.png";
import failedMark from "../assets/img/failed.png";
import pendingMark from "../assets/img/pending-mark.png";
import cal from "../assets/img/calendar1.png";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Table,
  Row,
  Col,
} from "reactstrap";

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const getLightVariant = (color) => {
  const lightenFactor = 0.7; // Adjust this factor as needed
  return color.replace(
    /^#/,
    (match) =>
      "#" +
      match
        .slice(1)
        .replace(/../g, (color) =>
          (
            "0" +
            Math.min(255, parseInt(color, 16) * lightenFactor).toString(16)
          ).slice(-2)
        )
  );
};

const TransactionItem = ({ title, totalFee, refundableFee, status }) => {
  const firstLetter = title.charAt(0).toUpperCase();
  const textColor = "#333"; // Dark text color
  const bgColor = getRandomColor();
  const lightBgColor = getLightVariant(bgColor);

  const roundImageStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: bgColor,
    color: "white",
    display: "inline-flex", // Display as inline-flex to have them side by side
    alignItems: "center",
    justifyContent: "center",
    padding: "5px", // Add padding for better spacing
    marginRight: "10px",
  };

  const textStyle = {
    // background: `linear-gradient(90deg, ${lightBgColor} 100%, transparent 100%)`,
    padding: "10px",
    borderRadius: "5px",
    color: "#222", // Dark text color
  };

  return (
    <td className="text-title">
      <div className="box-box">
        <div style={roundImageStyle} className="ball-mob">
          {firstLetter}
        </div>
      </div>
      <span style={textStyle} className="box-text">
        {title}
      </span>
    </td>
  );
};

function Tables() {
  const currentUser = AuthService.getCurrentUser();
  const id = currentUser.id;
  const [transaction, setTransaction] = useState([]);
  const [filter, setFilter] = useState("all");
  const [selectedTransaction, setSelectedTransaction] = useState(null);

   const retrieveTransaction = () => {
    AuthService.getAllTransaction(id)
      .then((response) => {
       // Sort transactions by date (newest first)
       const sortedTransactions = response.data.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      setTransaction(sortedTransactions);
    })
    .catch((e) => {
      //console.log(e);
    });
};

useEffect(() => {
  // Fetch data immediately on mount
  retrieveTransaction();
  
  // Set up interval to fetch data every 10 seconds
  const intervalId = setInterval(retrieveTransaction, 20000);
  
  // Clean up interval on unmount
  return () => clearInterval(intervalId);
}, []);


  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const handleRowClick = (transaction) => {
    setSelectedTransaction(transaction);
  };

  const closeModal = () => {
    setSelectedTransaction(null);
  };

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("modal-backdrop")) {
      closeModal();
    }
  };

  const formatDatew = (dateString) => {
    const date = new Date(dateString);

    // Define month names for short format
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Format date components
    const month = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0"); // Day with leading zero if needed
    const year = date.getFullYear();

    // Format time components
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Combine into desired format
    return `${month} ${day}, ${year} | ${hours}:${minutes}:${seconds}`;
  };
  const formatDatev = (dateString) => {
    const date = new Date(dateString);

    // Define month names for short format
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Format date components
    const month = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0"); // Day with leading zero if needed
    const year = date.getFullYear();

    // Format time components
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Combine into desired format
    return `${month} ${day}, ${year}`;
  };


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "short" }; // Using 'short' to get abbreviated month names
    return date.toLocaleDateString("en-US", options);
  };

  const filteredTransactions = transaction.filter((item) => {
    if (filter === "all") return true;
    return filter === "paid" ? item.status : !item.status;
  });

  return (
    <>
      {/* desktop-view  */}
      <div className="content tran-web">
        <Row className="auto-adjust tan-house">
          <Col lg="8" md="8" sm="4" className="house-all width-mob">
            <div className="typography-line-dash  welcome-msg  ">
              <h2>All Transactions</h2>
              <p>Your monthly transactions</p>
            </div>
          </Col>
          <Col
            lg="4"
            md="4"
            sm="2"
            className="width-2-mob"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Input
              type="select"
              name="statusFilter"
              id="statusFilter"
              value={filter}
              onChange={handleFilterChange}
            >
              <option value="all">All</option>
              <option value="paid">Paid</option>
              <option value="pending">Pending</option>
            </Input>

            {/* <div className="welcome-msg article-pan">
              <p className="article-pan-p">Oct</p>
              <img
                className="article-pan-img"
                src={cal}
                
                style={{ cursor: "pointer" }}
              />
            </div> */}
          </Col>
        </Row>

        <Row>
          <Col md="12">
            <Card className="outer-line">
              <CardBody className="Nobar">
                <Table responsive>
                  <thead className="text-primary">
                    <tr className="table-head">
                      <th>Transaction</th>
                      <th>Total Fee Cost</th>
                      <th>Date</th>
                      <th className="">Status</th>
                      <th>Transaction ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredTransactions.map((item, index) => (
                      <tr
                        key={item.id}
                        onClick={() => handleRowClick(item)}
                        className={
                          index % 2 === 0
                            ? "even-row cursor-pointer"
                            : "odd-row cursor-pointer"
                        }
                      >
                        {/* Use the new TransactionItem component */}
                        <TransactionItem
                          title={item.title}
                          totalFee={item.totalFee}
                          refundableFee={item.refundableFee}
                          status={item.status}
                        />
                        {/* <td className="text-title">{item.title}</td> */}
                        {/* <td>${parseFloat(item.totalFee).toFixed(2).toLocaleString()}</td> */}
                        <td className="fca">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(item.totalFee))}
                        </td>
                        <td className="dtaf">
                          {formatDatev(item.createdAt)}
                        </td>
                        <td className="text-status">
                          <div
                            className={`text-status-${
                              item.status ? "paid" : "pending"
                            }`}
                          >
                            {item.status ? (
                              <img src={checkMark} alt="Successful" />
                            ) : (
                              <img src={pendingMark} alt="Pending" />
                            )}
                            {item.status ? "Successful" : "Pending"}
                          </div>
                        </td>
                        <td className="fca td-end">
                          {item.transactionId}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal */}
        {selectedTransaction && (
          <div className="modal-backdrop" onClick={handleBackdropClick}>
            <div className="modal-content">
              <button className="close-button" onClick={closeModal}>
                ×
              </button>
              <h3>Transaction Receipt</h3>
              <div className="tran-rec-unit">
                <span>Amount</span>
                <h2>
                  {" "}
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(parseFloat(selectedTransaction.totalFee))}
                </h2>
              </div>
              <div className="tran-rec-unit">
                <span>Date</span>
                <h2> {formatDatew(selectedTransaction.createdAt)}</h2>
              </div>
              <div className="tran-rec-unit">
                <span>Payment Method</span>
                <h2> {selectedTransaction.paymentMethod}</h2>
              </div>
              <div className="tran-rec-unit">
                <span>Description</span>
                <h2> {selectedTransaction.description}</h2>
              </div>
              <div className="tran-rec-unit">
                <span>Transaction ID</span>
                <h2> {selectedTransaction.transactionId}</h2>
              </div>
              <div className="tran-rec-unit">
                <span>Status</span>
                <h2
                  className={`text-status-${
                    selectedTransaction.status ? "paid" : "pending"
                  }`}
                >
                  {" "}
                  {selectedTransaction.status ? (
                    <img src={checkMark} alt="Successful" />
                  ) : (
                    <img src={pendingMark} alt="Failed" />
                  )}
                  {selectedTransaction.status ? "Successful" : "Pending"}
                </h2>
              </div>
              {/* Add more details as needed */}
            </div>
          </div>
        )}
      </div>

      {/* transaction for mob  */}

      <div className="content tran-mob ">
        <Row className="auto-adjust tan-house">
          <Col lg="8" md="8" sm="4" className="house-all width-mob">
            <div className="typography-line-dash  welcome-msg  ">
              <h2>All Transactions</h2>
              <p>Your monthly transactions</p>
            </div>
          </Col>
          <Col
            lg="4"
            md="4"
            sm="2"
            className="width-2-mob"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Input
              type="select"
              name="statusFilter"
              id="statusFilter"
              value={filter}
              onChange={handleFilterChange}
            >
              <option value="all">All</option>
              <option value="paid">Paid</option>
              <option value="pending">Pending</option>
            </Input>

            {/* <div className="welcome-msg article-pan">
              <p className="article-pan-p">Oct</p>
              <img
                className="article-pan-img"
                src={cal}
                
                style={{ cursor: "pointer" }}
              />
            </div> */}
          </Col>
        </Row>

        <Row>
          <Col md="12">
            <Card className="outer-line">
              <CardBody className="Nobar">
                <Table responsive>
                  <thead className="text-primary">
                    <tr className="table-head">
                      <th>Transaction</th>
                      <th>Total Fee Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredTransactions.map((item, index) => (
                      <tr
                        key={item.id}
                        onClick={() => handleRowClick(item)}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        {/* Use the new TransactionItem component */}
                        <TransactionItem
                          title={item.title}
                          totalFee={item.totalFee}
                          refundableFee={item.refundableFee}
                          status={item.status}
                        />
                        {/* <td className="text-title">{item.title}</td> */}
                        {/* <td>${parseFloat(item.totalFee).toFixed(2).toLocaleString()}</td> */}
                        <td className="fca td-end">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(item.totalFee))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

         {/* Modal */}
         {selectedTransaction && (
          <div className="modal-backdrop" onClick={handleBackdropClick}>
            <div className="modal-content">
              <button className="close-button" onClick={closeModal}>
                ×
              </button>
              <h3>Transaction Receipt</h3>
              <div className="tran-rec-unit">
                <span>Amount</span>
                <h2>
                  {" "}
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(parseFloat(selectedTransaction.totalFee))}
                </h2>
              </div>
              <div className="tran-rec-unit">
                <span>Date</span>
                <h2> {formatDatew(selectedTransaction.createdAt)}</h2>
              </div>
              <div className="tran-rec-unit">
                <span>Payment Method</span>
                <h2> {selectedTransaction.paymentMethod}</h2>
              </div>
              <div className="tran-rec-unit">
                <span>Description</span>
                <h2> {selectedTransaction.description}</h2>
              </div>
              <div className="tran-rec-unit">
                <span>Transaction ID</span>
                <h2> {selectedTransaction.transactionId}</h2>
              </div>
              <div className="tran-rec-unit">
                <span>Status</span>
                <h2
                  className={`text-status-${
                    selectedTransaction.status ? "paid" : "pending"
                  }`}
                >
                  {" "}
                  {selectedTransaction.status ? (
                    <img src={checkMark} alt="Successful" />
                  ) : (
                    <img src={pendingMark} alt="Failed" />
                  )}
                  {selectedTransaction.status ? "Successful" : "Pending"}
                </h2>
              </div>
              {/* Add more details as needed */}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Tables;
